<template lang="pug">
  #create-new-account
    HeaderForLogin
    b-container.mx-auto.body-width.pb-2
      h2.text-center.pt-5.font-weight-bold.white-space アカウント情報を設定してください
      b-card.mt-4(header-tag="header")
        .form-box.mx-auto
          b-form
            b-modal#order_confirm(centered, size="ml", title="ご確認", @ok="createAccount", ok-title="はい", cancel-title="いいえ")
              span この内容でアカウントを作成します。<br>本当によろしいですか？
            b-row.border-top.ml-3.mr-1.mt-2
              b-col(:class="customer_title_col_class") ユーザー名
              b-col(:class="customer_input_col_class")
                b-form-input(size="sm", type="text", v-model="user_name.value", :placeholder="user_name.placeholder", :state="user_name.error_msg_list.length === 0 ? null: false")
                b-form-text.align-left.text-left.error-message-color(v-for="(message, key) of user_name.error_msg_list", :key="key") {{message}}
            b-row.border-top.ml-3.mr-1
              b-col(:class="customer_title_col_class") メールアドレス
              b-col(:class="customer_input_col_class")
                b-form-input(size="sm", type="text", v-model="mail_address.value", :placeholder="mail_address.placeholder", :state="mail_address.error_msg_list.length === 0 ? null: false")
                b-form-text.align-left.text-left ※ログイン時に使用するメールアドレスです。
                b-form-text.align-left.text-left.error-message-color(v-for="(message, key) of mail_address.error_msg_list", :key="key") {{message}}
            change-password-form(:password="password", :re_password="re_password")
            b-button.float-right.mr-3.mt-3(v-b-modal.order_confirm, :disabled="isSubmitButtonDisabled", variant="outline-success") 設定する
</template>

<script>
import ChangePasswordForm from "@/components/supportSite/ChangePasswordForm";
import Api from "@/repositories/api"
import HeaderForLogin from "@/components/supportSite/HeaderForLogin";

const S209CreateAccount = Api.get("s209CreateAccount")

export default {
  name: "CreateNewAccount",
  props: {
    client_no: {type: String, required: false},
  },
  components: {
    ChangePasswordForm,
    HeaderForLogin,
  },
  data() {
    return {
      customer_title_col_class: "py-2 px-2 border-right font-weight-bold table-title-col-width",
      customer_input_col_class: "py-2 px-2",

      // ユーザー名
      user_name: { placeholder: "山田　太郎", value: "", error_msg_list: [], class: "middle-form-size"},

      // メールアドレス
      mail_address: { placeholder: "someone@example.com", value: "", error_msg_list: [], class: "middle-form-size"},

      // パスワード
      password: { value: "", placeholder: "6文字以上・半角英数字記号", error_msg_list: [], class: "middle-form-size"},

      // パスワード(確認用)
      re_password: { value: "", placeholder: "確認のためにもう一度入力してください", error_msg_list: [], class: "middle-form-size"},

      // 「設定する」ボタン無効フラグ
      isSubmitButtonDisabled: false
    }
  },
  methods: {
    createAccount() {
      // エラーメッセージを初期化する
      this.user_name.error_msg_list    = []; // ユーザー名
      this.mail_address.error_msg_list = []; // メールアドレス
      this.password.error_msg_list     = []; // パスワード
      this.re_password.error_msg_list  = []; // パスワード(確認用)

      // リクエストデータ作成
      let requestData = {
        client_no:    this.client_no,          // お客様番号
        user_name:    this.user_name.value,    // ユーザー名
        mail_address: this.mail_address.value, // メールアドレス
        password:     this.password.value,     // パスワード
        re_password:  this.re_password.value   // パスワード(確認用)
      }

      // 「設定する」ボタンをロックする
      this.isSubmitButtonDisabled = true;

      // アカウント作成登録処理呼び出し
      S209CreateAccount.add(requestData)
      // 処理成功
      .then(() => {
        // アカウント作成受付画面へ遷移する
        this.$router.push({
          name: "AcceptNewAccount",
          params: {
            e_mail: this.mail_address.value
          }
        })
      })
      // 失敗
      .catch((error) => {
        // 「設定する」ボタンのロックを解除する
        this.isSubmitButtonDisabled = false;

        // 共通のエラー処理
        this.apiError(error, "登録処理")

        // バリデーションエラーの場合
        if (error.response.data && error.response.data.error_list) {
          for (let errorData of error.response.data.error_list) {
            // エラーメッセージの項目がある場合
            if (errorData.target !== undefined && this[errorData.target] !== undefined) {
              this[errorData.target].error_msg_list.push(errorData.error_msg)
            }
            // エラーメッセージの項目がお客様番号の場合
            else if (errorData.target === "client_no") {
              // エラー用の画面へ遷移する
              this.$router.push({
                name: "RelatedPasswordSetting",
                params: {
                  // 画面に表示するエラーメッセージ
                  error_msg: "予期せぬエラーが発生しました。ブラウザの再読み込みを行わないでください。\nお手数ですがログイン画面から再度アカウント作成の申込をしてください。"
                }
              })
            }
            // エラーメッセージの項目がない場合
            else {
              // エラー用の画面へ遷移する
              this.$router.push({
                name: "RelatedPasswordSetting",
                params: {
                  // 画面に表示するエラーメッセージ
                  error_msg: error.response.data.error_list[0].error_msg
                }
              })
            }
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.body-width {
  max-width: 1200px;
}
.form-box {
  max-width: 800px;
}
.middle-form-size {
  max-width: 500px;
}
.customer-title-bg-color {
  background-color: #f5f5f5;
}
.table-title-col-width {
  max-width: 180px;
}

</style>